<template>
  <span>
    <v-btn class="block md:hidden" style="position: fixed; z-index: 201; top: 0; right: 0" @click="open = !open">
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <v-card class="sidebar-wrap" :class="{'open': open}" style="border: none">
      <v-navigation-drawer
        v-model="drawer"
        class="light_black"
        dark
        :mini-variant.sync="mini"
        permanent
      > 
        <div class="flex flex-col h-[100%]">
          <v-list-item class="header " style="flex: unset">
            <v-list-item-avatar>
              <v-img src="@/assets/img/intestations/agency.png"></v-img>
            </v-list-item-avatar>

            <v-list-item-title></v-list-item-title>

            <v-btn
              class="hidden md:block"
              icon
              @click.stop="mini = !mini"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-list-item>

          <v-divider></v-divider>
          <div class="flex flex-col grow">
            <v-list dense>
              <v-list-item
                v-for="item in items"
                :key="item.title"
                :to="item.link"
                @click="closeWindow()"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div class="grow"></div>
            <v-list dense>
              <v-list-item>
                <v-select
                    v-if="!mini"
                    top
                    v-model="$i18n.locale"
                    :items="langs"
                    item-text="label"
                    item-value="value"
                    hide-selected
                    outlined
                    dense
                    @change="setLang($i18n.locale)"
                >
                </v-select>
              </v-list-item>
              <v-list-item @click="sidebar_logout()">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{$t('Logout')}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </div>
      </v-navigation-drawer>
      
    </v-card>
  </span>
</template>

<script>
export default {
   data() {
      return {
         drawer: false,
         open: false,
         mini: false,
      };
   },
   computed: {
      items(){
        let _items = []

        _items.push({ title: this.$t('Profilo'), link: "/account/data", icon: "mdi-account-circle" })
        _items.push({ title: this.$t('I miei lavori'), link: "/works", icon: "mdi-briefcase" })
        _items.push({ title: this.$t('Esplora lavori'), link: "/proposals", icon: "mdi-briefcase-search" })
        _items.push({ title: this.$t('Impostazioni'), link: "/account/settings", icon: "mdi-cog" })
        
        return _items
      },
      user() {
        let user = this.$store.getters['user/user']
        return user
      },
      account() {
         let t = this.$store.getters['account/getAccount']
         return t
      },
   },
   methods: {
      async closeWindow(){
        await this.delay(300)
        this.open = false
        
      },
      sidebar_logout(){
        this.$store.commit("main_loader", true);
        this.logout()
        this.delay(1000)

        this.$router.push({ name: "login" })
      },
   },
};
</script>

<style lang="scss" scoped>
/*  */
.sidebar-wrap{

  height: 100%;

  @media screen and (max-width: $M) {
    position: fixed;
    width: 0;
    opacity: 0;
    pointer-events: none;
    transition: all .3s ease,
    width 0 ease;
    background-color: rgba(black, 0) !important;
  
    &.open{
      display: block;
      pointer-events: all;
      
      width: 100vw;
      opacity: 1;
      background-color: rgba(black, .7) !important;
      z-index: 200;
  
      & > .v-navigation-drawer {
        width: 480px !important;
        transform: translateX(0%);

        @media screen and (max-width: 480px) {
          width: 100vw !important;
        }
      }
    }
  
    &:not(.open){
      & > .v-navigation-drawer{
        transform: translateX(-100%) !important;
        transition: transform 2s ease;
      }
    }
  }

  @media screen and (min-width: $M){
    .v-navigation-drawer:not(.v-navigation-drawer--mini-variant){
      width: 220px !important;
    }
  }

  & > .v-navigation-drawer {
    display: block;
    position: sticky !important;
    top: 0;
    left: 0;
    height: 100vh !important;

    
    
  }
}
.v-list-item--density-compact.v-list-item--one-line{
      transition: all .3s ease;
}
.v-list-item__prepend > *{
  transition: all .3s ease;
}
.v-list-item{
   transition: all .3s ease;
   width: 100%;
}
.v-navigation-drawer--mini-variant{
   // background: grey !important;
   .v-list-item{
      &:not(.header){
         width: 56px;
         display: flex;
         padding-left: 16px;
      }
      &.header{
         padding-left: 9px;
      }
   }
}
</style>